import { Component, createMemo, JSX, Show } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import {
  SelectionTreeVisibleContentRenderer,
  TreeNodeDefinition,
} from './types';

export interface SelectionTreeSlotContentProps<T = unknown> {
  node: TreeNodeDefinition<T>;
  nodes: readonly TreeNodeDefinition<T>[];
  treeSlot?: SelectionTreeVisibleContentRenderer<T>;
  nodeSlot?: Component;
}

export const SelectionTreeSlotContent = <T,>(
  props: SelectionTreeSlotContentProps<T>
): JSX.Element => {
  const treeContent = createMemo(() =>
    props.treeSlot?.({
      node: props.node,
      nodes: props.nodes,
    })
  );

  // Only a nullish result falls back to the node slot. `false`, `''` and `0`
  // mean the tree slot handled the row.
  const hasTreeContent = (): boolean => {
    const content = treeContent();
    return content !== undefined && content !== null;
  };

  return (
    <Show
      when={hasTreeContent()}
      fallback={
        <Show when={props.nodeSlot} keyed>
          {(content) => <Dynamic component={content} />}
        </Show>
      }
    >
      {treeContent()}
    </Show>
  );
};
